export default [
  { value: 'Active', label: 'Active' },
  { value: 'Active(with contract)', label: 'Active(with contract)' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Contingency', label: 'Contingency' },
];
